import { InjectionToken } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { RootState } from './store/store.state';
import { routerReducer } from '@ngrx/router-store';

export let APP_SETTINGS = new InjectionToken('app-settings');

export interface IAppSettings {
    apiEndpoint: string;
}

export const AppSettings: IAppSettings = {
    apiEndpoint: '/api/'
};

export const ROOT_REDUCERS = new InjectionToken<
    ActionReducerMap<Partial<RootState>>
>('Root reducers token', {
    factory: () => ({
        router: routerReducer
    })
});
